export default "__VITE_ASSET__7e1761e6__"